import { SwapDownIcon } from "@src/assets";
import { CashAmountPanel } from "./CashAmountPanel";
import { useMemo } from "react";
import { useSwapContext } from "@src/contexts";
import { useTokenBalance } from "@src/hooks";

export const CashBridgePanel = () => {
  const { cashBridgeAmount, cashToken } = useSwapContext();
  const tokenBalances = useTokenBalance({ token: cashToken });

  const isAmountValid = useMemo(() => {
    if (Number(tokenBalances.humanReadable) < Number(cashBridgeAmount)) {
      return false;
    }
    return true;
  }, [tokenBalances, cashBridgeAmount]);

  return (
    <div className="flex flex-col gap-1">
      <div
        className={`flex flex-col rounded-xl ${
          isAmountValid ? "bg-card_bg" : "bg-error_light/10"
        }`}
      >
        <CashAmountPanel type={"source"} />
      </div>

      <div className="relative">
        <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-[25px] h-[25px]">
          <SwapDownIcon />
        </div>
      </div>
      <div className="flex flex-col rounded-[12px] bg-theme_color bg-opacity-20">
        <CashAmountPanel type={"destination"} />
      </div>
    </div>
  );
};
